export default "/assets/images/mila-feed-07.mp4?47fe5b6e44298b95ab314fcb3635aff1";